import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import assesmentlistService from "./assesmentService";

export const getAssesmentList = createAsyncThunk(
  "assesmentlist/get-assesmentlist",
  async (thunkAPI) => {
    try {
      return await assesmentlistService.getAssesmentList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAssesmentOverviewList = createAsyncThunk(
  "assessmentOverviewList/get-assessmentOverviewList",
  async (thunkAPI)=>{
    try {
      return await assesmentlistService.getAssesmentOverviewList ();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
)

export const resetState = createAction("Reset_all");

const initialState = {
  assessmentlists: [],
  assessmentOverviewlists:[],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const assesmentlistSlice = createSlice({
  name: "assessmentlist",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAssesmentList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAssesmentList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.assessmentlists = action.payload;
  
      })
      .addCase(getAssesmentList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAssesmentOverviewList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAssesmentOverviewList.fulfilled, (state, action) => {        
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.assessmentOverviewlists = action.payload;
  
      })
      .addCase(getAssesmentOverviewList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default assesmentlistSlice.reducer;
